module.exports = __webpack_public_path__ + "602167b0a53279de5a8378a9d9c2b8d8.pdf";